import React, { useState } from "react";
import "./Login.css";
import LoginLogo from "../../Components/Assets/images/logo2.png";
import { useNavigate } from "react-router-dom";
import { account, tablesDB, DB_ID, USERS_TABLE } from "../../appwrite";
import { useTitle } from "../../hooks/useTitle";
import { Eye, EyeOff } from "lucide-react";

function Login() {
  useTitle("Admin Dashboard");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await account.createEmailPasswordSession(email, password);
      const user = await account.get();

      const userDoc = await tablesDB.getRow({
        databaseId: DB_ID,
        tableId: USERS_TABLE,
        rowId: user.$id,
      });

      if (userDoc.userRole === "admin") {
        navigate("/");
      } else {
        await account.deleteSession("current");
        setError("ACCESS DENIED! Admin access only.");
      }
    } catch (err) {
      try {
        await account.deleteSession("current");
      } catch {}
      const msg = err?.message || "";
      if (msg.includes("Invalid credentials") || msg.includes("password")) {
        setError("Invalid email or password.");
      } else if (msg.includes("not found") || err?.code === 404) {
        setError("Admin not found in database.");
      } else {
        setError("Access denied.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <a href="/">
          <img className="auth-logo" src={LoginLogo} alt="TrendBay" />
        </a>
        <div className="auth-badge">🔐 Admin Portal</div>
        <h1 className="auth-heading">Admin Sign In</h1>
        <p className="auth-sub">
          Restricted access - authorised personnel only
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="auth-field">
            <label className="auth-label">Email address</label>
            <input
              className="auth-input"
              type="email"
              placeholder="email@trendbayds.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              disabled={loading}
              required
            />
          </div>
          <div className="auth-field">
            <label className="auth-label">Password</label>
            <div className="auth-pw-wrap">
              <input
                className="auth-input"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                disabled={loading}
                required
              />
              <span
                className="auth-pw-toggle"
                onClick={() => setShowPassword((p) => !p)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>
          <button type="submit" className="auth-btn-primary" disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className="auth-footer-text">
          <a href="https://mart.trendbayds.com">← Back to TrendBay Mart</a>
        </p>
      </div>
    </div>
  );
}

export default Login;
